export interface IPersonalInfo {
  surname: string;
  otherName: string;
  email: string;
  phoneNumber: string;
}

export interface IQuestion {
  doYouHaveWill: boolean | string;
  doYouHaveSpouse: boolean | string;
  doYouHaveUnderAgeChild: boolean | string;
  doYouHaveInsurance: boolean | string;
  doYouHavePensionAccount: boolean | string;
}

export interface IQuestionTwo {
  doYouHaveEmployeeBenefit: boolean | string;
  doYouHaveBankAccount: boolean | string;
  doYouHaveBondShare: boolean | string;
  doYouHaveAsset: boolean | string;
  doYouHaveSpecialInstruction: boolean | string;
  doYouNeedTrustee: boolean | string;
}

export interface IPassword {
  password: string;
  confirmPassword: string;
}

export interface IGetStarted
  extends IPersonalInfo,
    IQuestion,
    IQuestionTwo,
    IPassword {
  planId: number | null;
  planAmount: number | null;
  reference: string | null;
}

export const InitialValues = {
  surname: '',
  otherName: '',
  email: '',
  phoneNumber: '',
  doYouHaveWill: '',
  doYouHaveSpouse: '',
  doYouHaveUnderAgeChild: '',
  doYouHaveInsurance: '',
  doYouHavePensionAccount: '',
  doYouHaveEmployeeBenefit: '',
  doYouHaveBankAccount: '',
  doYouHaveBondShare: '',
  doYouHaveAsset: '',
  doYouHaveSpecialInstruction: '',
  doYouNeedTrustee: '',
  password: '',
  confirmPassword: '',
  planId: null,
  planAmount: null,
  reference: null
};

export const InitialSetupValues = {
  surname: '',
  otherName: '',
  email: '',
  phoneNumber: '',
  password: '',
  confirmPassword: '',
  planId: null,
  planAmount: null,
  reference: null
};

export interface SimpleGetStarted extends IPersonalInfo, IPassword {
  planId: number | null;
  planAmount: number | null;
  reference: string | null;
}
